import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
	name: 'dateWithoutTime'
})
export class DateWithoutTimePipe implements PipeTransform {
	transform(value: string): string {
		if (!value) {
			return '';
		}
		const date = new Date(value);
		const formattedDate = date.toISOString().split('T')[0];
		return formattedDate;
	}
}
